import { pageStructuredData } from '@surfline/web-common';
import Head from 'next/head';
import React from 'react';

import config from '../../../config';
import { SpotDetails } from '../../../types/spot';

interface Props {
  activeCollection: {
    _id: string;
    name: string;
    loading: boolean;
    type: string;
    error: boolean;
    fetchedSpots: boolean;
    spots: SpotDetails[];
  };
}

interface Link {
  rel: string;
  href: string;
  title?: string;
}

const SurfCamsTags: React.FC<Props> = ({ activeCollection }) => {
  const title = `Surf Cams - Watch Live Beach Webcams in HD - Surfline`;
  const description = `Surfline’s global network of surf cams includes multiple views of spots, pinch-to-zoom effects and a host of new locations. Strategically placed, these real-time, HD-quality surf checks allow you to view waves and beach conditions from Manasquan to Malibu, Nazare to Newport, Oahu’s Seven Mile Miracle to Waco’s fresh-water skatepark, and hundreds of world-famous surf breaks in between.`;

  const seoUrl = `${config.hostForSEO}/surf-cams`;
  const link: Link[] = [
    {
      rel: 'canonical',
      href: seoUrl,
    },
  ];

  const meta = [
    {
      name: 'description',
      content: description,
    },
    {
      property: 'og:title',
      content: title,
    },
    {
      property: 'og:url',
      content: link[0].href,
    },
    {
      property: 'og:image',
      content: config.facebookOGImage,
    },
    {
      property: 'og:description',
      content: description,
    },
    {
      property: 'twitter:title',
      content: title,
    },
    {
      property: 'twitter:url',
      content: link[0].href,
    },
    {
      property: 'twitter:image',
      content: config.twitterOGImage,
    },
    {
      property: 'twitter:description',
      content: description,
    },
  ];

  const robotsMeta = config.robots
    ? {
        name: 'robots',
        content: config.robots,
      }
    : null;

  if (robotsMeta) {
    meta.push(robotsMeta);
  }
  const camStill = activeCollection?.spots?.[0]?.cameras?.[0]?.stillUrl;

  return (
    <Head>
      <title>{title}</title>
      {meta.map((m) => (
        <meta property={m.property} content={m.content} key={m.property || m.name} name={m.name} />
      ))}
      {link.map((l) => (
        <link rel={l.rel} href={l.href} key={`${l.href}-${l.rel}`} title={l.title} />
      ))}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: pageStructuredData({
            url: `${config.hostForSEO}/surf-cams`,
            headline: 'Premium Members Can Access up to Nine Cams at Once with Multi-Cam',
            dateModified: '10/1/2019',
            author: 'Surfline Forecast Team',
            description,
            cssSelector: '.sl-multi-cam-surf-report',
            image: camStill,
          }),
        }}
      />
    </Head>
  );
};

export default SurfCamsTags;
